import React, { useEffect, useState } from 'react';
import Banners from './components/banners/Banners';
import './Home.scss';
import SearchTrainTickets from './components/searchTrainTickets/SearchTrainTickets';
import Benefits from './components/benefits/Benefits';
import AppAdvertisement from './components/appAdvertisement/AppAdvertisement';
import { getHomePageContent } from '../../../../services/customer/pageContentServices';
import useTranslation from '../../../hooks/translation/useTranslation';

function Home() {
  const { configInfo } = useTranslation();
  const is_uiwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test(navigator.userAgent);
  const [homePageContent, setHomePageContent] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await getHomePageContent();
        setHomePageContent(res.data);
      } catch {
        setHomePageContent({});
      }
    };

    fetchData();
  }, []);

  return (
    <div className="flex flex-col gap-20">
      <Banners banners={homePageContent?.banners} />
      <SearchTrainTickets />
      {homePageContent?.benefits?.length ? <Benefits benefits={homePageContent?.benefits} />
        : <div className="h-[160px] lg:block hidden" />}
      {!is_uiwebview && configInfo?.countryCode === 'GE' && <AppAdvertisement />}
    </div>
  );
}

export default Home;
